exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nol[data-v-2fee9a9e] {\n  counter-reset: item;\n}\nli[data-v-2fee9a9e] {\n  display: block;\n  padding: 8px;\n}\nli[data-v-2fee9a9e]:before {\n  content: counters(item, '.') ' ';\n  counter-increment: item;\n  position: absolute;\n  left: 6%;\n}\nol li[data-v-2fee9a9e] {\n  margin-left: 8px;\n}\nol li ol li[data-v-2fee9a9e]:before {\n  left: 8%;\n}\nol li ol li[data-v-2fee9a9e] {\n  margin-left: 32px;\n}\n", ""]);

// exports
